module.exports = __webpack_public_path__ + "static/media/Logo_Here.105df13e.png";